"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenExpandCloseButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FullscreenExpandCloseButton, _Component);

  function FullscreenExpandCloseButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenExpandCloseButton.prototype;

  _proto.closeButtonCreated = function closeButtonCreated(buttonElement) {
    this.closeButton = buttonElement;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.closeButton && this.props.shoudAutofocus) {
      this.closeButton.focus && this.closeButton.focus();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.shouldRefocusOnCloseXButton && !prevProps.shouldRefocusOnCloseXButton) {
      this.focusOnCloseXButton();
    }
  };

  _proto.focusOnCloseXButton = function focusOnCloseXButton() {
    if (this.closeButton) {
      this.closeButton.focus && this.closeButton.focus();
    }
  };

  _proto.render = function render() {
    var _this = this;

    return _react["default"].createElement("button", {
      className: "fullscreen-icon fullscreen-close " + this.props.iconClass,
      onClick: function onClick() {
        return _this.props.onClick();
      },
      tabIndex: this.props.tabIndex,
      "aria-label": this.props.title,
      ref: function ref(button) {
        return _this.closeButtonCreated(button);
      }
    });
  };

  return FullscreenExpandCloseButton;
}(_react.Component);

var _default = FullscreenExpandCloseButton;
exports["default"] = _default;